import { useEffect } from 'react';

import { useIsRealRevelioAdmin } from '@revelio/auth';

import { useDataInspectorStore } from './data-inspector.store';

/**
 * Pushes the viewer's permission into the store so the recorder exchange —
 * which is created outside the React tree and cannot use hooks — can see it.
 *
 * This is what makes the permission a real kill switch. The user's toggle is
 * persisted to localStorage, so without this, a non-admin session would leave
 * anyone who had already switched the mode on still capturing request bodies
 * indefinitely.
 */
export const DataInspectorAccessSync = () => {
  const isRevelioAdmin = useIsRealRevelioAdmin();
  const setPermitted = useDataInspectorStore((state) => state.setPermitted);

  useEffect(() => {
    setPermitted(isRevelioAdmin);
  }, [isRevelioAdmin, setPermitted]);

  return null;
};
